import React from 'react';
import { Checkbox as DLSCheckbox } from '@americanexpress/dls-react';
import { CheckboxViewModel } from 'src/types/view-models/checkbox.view.model';

export default function Checkbox({ onChange, 'data-cy': dataCy, ...props }: CheckboxViewModel): JSX.Element {
    return (
        <div onClick={onChange} data-cy={dataCy}>
            <DLSCheckbox {...props} />
        </div>
    );
}
